import React from 'react';
import { Typography } from 'design-system';
import { dsPaletteShowcaseGroups } from './palettes';
import { paletteSwatchTextClass } from './paletteUtils';

function PaletteColumn({ col }) {
  return (
    <div className="ds-palette-showcase__column">
      <div className="ds-palette-showcase__column-title">{col.label}</div>
      {col.kind === 'palette' && (
        <>
          <div className="ds-palette-showcase__stack">
            {col.solid.map((sw) => (
              <div
                key={`${col.family}-solid-${sw.step}`}
                className={`ds-palette-swatch ${paletteSwatchTextClass(sw.value)}`}
                style={{ background: sw.value }}
                title={sw.cssVar}
              >
                <span className="ds-palette-swatch__label">{sw.rowLabel}</span>
                <code className="ds-palette-swatch__hex">{sw.value}</code>
              </div>
            ))}
          </div>
          {col.alpha.length > 0 && (
            <>
              <div className="ds-palette-showcase__alpha-gap" aria-hidden />
              <div className="ds-palette-showcase__stack">
                {col.alpha.map((sw) => (
                  <div
                    key={`${col.family}-alpha-${sw.step}`}
                    className={`ds-palette-swatch ${paletteSwatchTextClass(sw.value)}`}
                    style={{ background: sw.value }}
                    title={sw.cssVar}
                  >
                    <span className="ds-palette-swatch__label">{sw.rowLabel}</span>
                    <code className="ds-palette-swatch__hex">{sw.value}</code>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
      {col.kind === 'linear-stack' && (
        <div className="ds-palette-showcase__stack">
          {col.rows.map((row) => (
            <div
              key={row.cssVar}
              className="ds-palette-swatch ds-palette-swatch--gradient"
              style={{ backgroundImage: row.value }}
              title={row.value}
            >
              <span className="ds-palette-swatch__label">{row.rowLabel}</span>
              <code className="ds-palette-swatch__hex">{row.cssVar}</code>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function PaletteShowcase() {
  return (
    <div className="design-system-section">
      <Typography variant="h1" className="section-title mb-4">
        Color palettes
      </Typography>
      <div className="ds-showcase-separator mb-5" />
      {dsPaletteShowcaseGroups.map((group) => (
        <div key={group.id} className="ds-palette-showcase__section">
          <Typography variant="h3" component="h2" className="ds-palette-showcase__section-title">
            {group.title}
          </Typography>
          {group.description && (
            <p className="ds-palette-showcase__section-desc">{group.description}</p>
          )}
          <div className="ds-palette-showcase__columns">
            {group.columns.map((col) => (
              <PaletteColumn key={col.family} col={col} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
